/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import "babel-polyfill";
import "bundle/util/Polyfill";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import { getQueryStringParameterByName } from "bundle/util/UriUtils";
import messageReceiver from "app/core/MessageReceiver";
import MessagingService from "common/service/MessagingService";
import DCInitService from "app/preview/service/DCInitService";
import CMPToolService from "app/preview/service/CMPToolService";
import LoggingService from "app/preview/service/LoggingService";
import CallbackService from "common/service/CallbackService";

const _registerServices = () => {
    ServiceRegistry.register("LoggingService", new LoggingService());
    ServiceRegistry.register("DCInitService", new DCInitService());
    ServiceRegistry.register("CMPToolService", new CMPToolService());
    const messageSessionId = getQueryStringParameterByName("msi", window.location.search);
    ServiceRegistry.register("MessagingService", new MessagingService());
    ServiceRegistry.getService("MessagingService").setSessionId(messageSessionId);
    ServiceRegistry.register("CallbackService", new CallbackService());
};

window.userLocale = getQueryStringParameterByName("locale", window.location.search) || "en-US";

class ViewSDK {
    initialize = () => {
        _registerServices();
        messageReceiver.initialize();
    };
}

const viewSDK = new ViewSDK();
viewSDK.initialize();
